import { render, staticRenderFns } from "./edit-box.vue?vue&type=template&id=444fb097&scoped=true"
import script from "./edit-box.vue?vue&type=script&lang=js"
export * from "./edit-box.vue?vue&type=script&lang=js"
import style0 from "./edit-box.vue?vue&type=style&index=0&id=444fb097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444fb097",
  null
  
)

export default component.exports